import { FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'
import { DescriptionProps } from './interfaces'

export const ContainerEditEmail = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100vw;
  height: 100vh;
`

export const TitleEditEmail = styled(FuelTypography).attrs({ as: 'h1' })`
  font-style: normal;
  font-weight: ${({theme}) => theme.font.weight.bold};
  font-size: ${({theme}) => theme.font.size.m5};
  line-height: ${({theme}) => theme.font.lineHeight.tiny};
  color: ${({theme}) => theme.color.text.neutral.strong};
  margin: ${({theme}) => theme.spacing.km4} 0 ${({theme}) => theme.spacing.km3} 0;
`

export const DescriptionEditEmail = styled(FuelTypography).attrs({ as: 'p'})<DescriptionProps>`
  font-style: normal;
  font-weight: ${({theme}) => theme.font.weight.medium};
  font-size: ${({theme}) => theme.font.size.m4};
  line-height: ${({theme}) => theme.font.lineHeight.medium};
  color: ${({theme}) => theme.color.text.neutral.default};
  text-align: center;
  margin-bottom: ${({theme}) => theme.spacing.km6};
  max-width: ${({$width}) => $width};
  max-height: ${({$height}) => $height};
`
